import { render, staticRenderFns } from "./hiddenDangerTreatment.vue?vue&type=template&id=bd8535c2&scoped=true"
import script from "./hiddenDangerTreatment.vue?vue&type=script&lang=js"
export * from "./hiddenDangerTreatment.vue?vue&type=script&lang=js"
import style0 from "./hiddenDangerTreatment.vue?vue&type=style&index=0&id=bd8535c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8535c2",
  null
  
)

export default component.exports